import React, { useEffect, useState } from "react";

import Stack from "react-bootstrap/Stack";
import Form from "react-bootstrap/Form";

import { DateInputWrapper } from "../../../components/DateInputWrapper";

export default function SelectPaymentDueDate({
  dueDateOpt,
  setDueDateOpt,
  customDueDate,
  setCustomDueDate,
}) {
  const dueDateOpts = [
    {
      value: "0",
      label: "Today",
    },
    {
      value: "1",
      label: "Tomorrow",
    },
    {
      value: "7",
      label: "7 days",
    },
    {
      value: "14",
      label: "14 days",
    },
    {
      value: "30",
      label: "30 days",
    },
    {
      value: "45",
      label: "45 days",
    },
    {
      value: "60",
      label: "60 days",
    },
    {
      value: "90",
      label: "90 days",
    },
    {
      value: "custom",
      label: "Custom",
    },
  ];

  // add default due date option on mount - 30 days
  useEffect(() => {
    setDueDateOpt(dueDateOpts[4]?.value);
  }, []);

  // reset custom due date whenever dueDate change
  useEffect(() => {
    setCustomDueDate(new Date());
  }, [dueDateOpt]);

  return (
    <Stack gap={3}>
      <Form.Group controlId="dueDate">
        <Form.Label>Due Date</Form.Label>
        <Form.Select
          onChange={(e) => setDueDateOpt(e.target.value)}
          value={dueDateOpt}
        >
          {dueDateOpts?.map((date, idx) => (
            <option key={idx} value={date?.value}>
              {Number(parseInt(date?.value)) > 1 ? "Due in" : ""} {date?.label}
            </option>
          ))}
        </Form.Select>
      </Form.Group>
      {dueDateOpt === "custom" && (
        <div>
          <Form.Label htmlFor="custom-date">Select custom date</Form.Label>
          <DateInputWrapper
            size="sm"
            id="custom-date"
            minDate={new Date()}
            setDate={setCustomDueDate}
            selectedDate={customDueDate}
          />
        </div>
      )}
    </Stack>
  );
}
